import React from "react";
import "./whatsappChannelBanner.scss";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import { Button, Col, Image, Row, Stack } from "react-bootstrap";
import { t } from "i18next";
import { Trans } from "react-i18next";

const whatsappChannelBanner = () => {
  return (
    <div className="whatsapp-channel-banner-container w-100">
      <Stack
        gap={3}
        className="stack-whatsapp-channel-banner-container d-flex justify-content-center align-items-center p-3"
      >
        <Image
          fluid
          src="/invitation_volunteer.png"
          alt="img_invite"
          className="w-100"
          style={{ borderRadius: 0 }}
        />
        <div className="w-100">
          <Trans
            i18nKey="home.subtitle_whatsapp_channel_banner"
            components={{ bold: <strong /> }}
          />
        </div>
        <Button
          variant="success"
          onClick={() =>
            window.open(
              "https://whatsapp.com/channel/0029Vb5OU5jA89Mh9wvIEm0o ",
              "_blank"
            )
          }
          style={{ borderRadius: 15 }}
        >
          <Stack direction="horizontal" gap={1}>
            <WhatsAppIcon />
            {t("common.join_now")}
          </Stack>
        </Button>
      </Stack>
    </div>
  );
};

export default whatsappChannelBanner;
